import React from "react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { links } from "./SuperAdminPages";
import IntegrationsCenter from "../../components/IntegrationsCenter";

export default function SuperAdminIntegrations() {
  return (
    <DashboardLayout links={links} title="Integrations & Settings">
      <IntegrationsCenter scope="platform" />
    </DashboardLayout>
  );
}
